import { Injectable, Signal, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OnlineStatusService {
  private onlineSignal = signal(navigator.onLine);

  online: Signal<boolean> = computed(() => this.onlineSignal());

  constructor() {
    window.addEventListener('online', () => this.onlineSignal.set(true));
    window.addEventListener('offline', () => this.onlineSignal.set(false));
  }
}
